import { connect } from 'react-redux';
import { Features, IFeaturesProps } from '../../components/Features';
import { getHasProgressOfConstruction } from '../../selectors/newbuilding';
import { TApplicationState } from '../../types/redux';
import { trackOpenProgressOfConstruction } from '../../actions/analytics';

type TFeaturesDispatchProps = Pick<IFeaturesProps, 'trackOpenProgressOfConstruction'>;

type TFeaturesStateProps = Pick<IFeaturesProps, 'hasProgressOfConstruction' | 'path'>;

export function mapStateToProps(state: TApplicationState): TFeaturesStateProps {
  const { isNewbuildingSubdomain } = state.common;

  return {
    hasProgressOfConstruction: getHasProgressOfConstruction(state),
    path: isNewbuildingSubdomain ? '/' : state.path,
  };
}

export function mapDispatchToProps(): TFeaturesDispatchProps {
  return {
    trackOpenProgressOfConstruction,
  };
}

export const FeaturesContainer = connect(mapStateToProps, mapDispatchToProps)(Features);
